import { Directive, DirectiveBinding } from 'vue';
import { useFeatureAccessValidator } from '@/composables/use-feature-access-validator';
import { RoleProtectedFeature } from '@/types/feature-names';

const PermissionDirective: Directive<HTMLElement, RoleProtectedFeature> = (
    element: HTMLElement,
    binding: DirectiveBinding<RoleProtectedFeature>
): void => {
    const { validateAccess } = useFeatureAccessValidator();
    const hasAccess: boolean = validateAccess(binding.value);

    if (hasAccess) {
        return;
    }

    element.remove();
};

export default PermissionDirective;
